// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#underline-parent[data-v-7f5b04d1] {\n  background-color: var(--v-light-panel);\n}\n.hover-item[data-v-7f5b04d1] {\n  background-color: var(--v-pilot-base);\n  transition: 0.4s all;\n}\n.hover-item[data-v-7f5b04d1]:hover {\n  background-color: var(--v-pilot-lighten1);\n}\n", ""]);
// Exports
module.exports = exports;
